import type { UserDataIF } from "interfaces/UserDataIF"
import type { CurrentUserType } from "usecases/firebase/auth"
export const deserializeUserData = (
  currentUser: CurrentUserType,
): UserDataIF => {
  if (!currentUser) {
    return {
      uid: null,
      email: null,
      emailVerified: false,
      isAuth: false,
      isFirebaseInitialized: true,
    }
  }

  return {
    uid: currentUser.uid || null,
    email: currentUser.email || null,
    emailVerified: currentUser.emailVerified,
    isAuth: true,
    isFirebaseInitialized: true,
  }
}
